import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation(); // for active link highlight

  const toggleMenu = () => setIsOpen(!isOpen);

  const closeMenu = () => setIsOpen(false);

  return (
    <nav className="navbar">
      {/* Logo */}
      <div className="navbar-logo">
        <Link to="/" onClick={closeMenu}>
          <span className="glow-text">SAMSOFTIX</span>
        </Link>
      </div>

      {/* Hamburger Menu */}
      <div className={`hamburger ${isOpen ? "active" : ""}`} onClick={toggleMenu}>
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* Navigation Links */}
      <ul className={`navbar-links ${isOpen ? "active" : ""}`}>
        <li>
          <Link
            to="/"
            onClick={closeMenu}
            className={location.pathname === "/" ? "active-link" : ""}
          >
            Home
          </Link>
        </li>

        <li>
          <Link
            to="/about"
            onClick={closeMenu}
            className={location.pathname === "/about" ? "active-link" : ""}
          >
            About
          </Link>
        </li>

        <li>
          <Link
            to="/contactUs"
            onClick={closeMenu}
            className={location.pathname === "/contactUs" ? "active-link" : ""}
          >
            Contact Us
          </Link>
        </li>

        <li>
          <Link
            to="/privacy"
            onClick={closeMenu}
            className={location.pathname === "/privacy" ? "active-link" : ""}
          >
            Privacy
          </Link>
        </li>
        <li>
          <Link
            to="/advertising"
            onClick={closeMenu}
            className={location.pathname === "/advertising" ? "active-link" : ""}
          >
            Advertising Policy
          </Link>
        </li>
      </ul>
    </nav>
  );
}
